import { useState } from 'react';
import Timebox from '@/components/common/CalendarWeekly/Timebox';
import { DAYS } from '@/components/common/CalendarWeekly/constant';

const DATE_COUNT = 7

const Calendar =
	({
		 hours,
		 courts,
		 selectedDay,
		 selectedSchedules,
		 setSelectedDay,
		 setSelectedSchedules,
		 prices = [],
		 hideEmptyPrice = false,
		 calendarWeeklyItems = [],
		 weeksCount = 1
	} : CalendarWeeklyProps): JSX.Element => {
	const [selectedField, setSelectedField] = useState([])
	// const [selectedField, setSelectedField] = useState([])
	const renderDates = () : JSX.Element[] => {
		const dates = []
		for (let i=0; i<DATE_COUNT; i+=1) {
			const isDaySelected = i === selectedDay ?
				'bg-red-primary text-white' :
				'border border-grey-line-subtle'
			const DATE = {
				day: DAYS[i].label,
				value: DAYS[i].value,
			}
			dates.push(
				<div className='flex flex-grow flex-col items-center gap-2'>
					<div
						className={`flex flex-col justify-between items-center w-full py-2 gap-1 rounded ${isDaySelected}`}
						onClick={() => {
							setSelectedDay(DATE.value);
							setSelectedField([])
						}}
						role="button"
						tabIndex={0}
						onKeyDown={() => {
							setSelectedDay(DATE.value);
						}}>
						<p className='font-bold'>{`${DATE.day}`}</p>
					</div>
				</div>
			)
		}
		return dates
	}

	const priceKey = (priceId: string, dayType: string, startHour: number, endHour: number): string => 
	 `${priceId}_${dayType}_${startHour}_${endHour}`
	
	const allPrices = new Map<string, number>()
	prices.forEach((price) => {
		price.details.forEach((detail) => {
			if (detail.type === 'REGULAR' && detail.day_type !== 'HOLIDAY') {
				for (let hour = detail.start_time; hour <= detail.end_time; hour += 1) {
					const key = priceKey(price.id, detail.day_type, hour, hour + 1)
					allPrices.set(key, detail.price)
				}
			}
		})
	})

	const calendarKey = (courtId: string, startHour: number, endHour: number): string => 
	 `${courtId}_${startHour}_${endHour}`
	const calenderItems = new Map<String, number[]>()
	calendarWeeklyItems.forEach((item) => {
		const key = calendarKey(item.venue_court_id, item.start_time, item.end_time)
		const exist = calenderItems.get(key)
		if (typeof exist !== 'undefined') {
			if (!exist.includes(item.date)) exist.push(item.date)
		} else {
			calenderItems.set(key,  [item.date])
		}
		calenderItems.get(key).sort()
	})
	const dayType = (selectedDay === 0 || selectedDay === 6) ? 'WEEKEND' : 'WEEKDAYS'

	return (
		<div className='py-4'>
			<div>
				<div className='flex items-center px-8 py-4 gap-3'>{renderDates()}</div>
			</div>
			<div className='flex justify-around w-full pr-7'>
				<div className='flex justify-around w-full'>
					<div className='flex flex-col items-center basis-1/12 h-full'>
						<div className='flex h-4'> </div>
						{hours.map(hour => (<div className='flex h-12 font-medium text-sm text-grey-dark'>{`${hour}.00`}</div>))}
					</div>
					{courts.map(court => (
							<div className='flex flex-col flex-grow h-full basis-1/6'
									 key={court.id}>
								<div className='flex justify-center'> <p>{`${court.code}`}</p></div>
								{hours.map((hour) => (
									<Timebox 
										hour={hour}
										court={court}
										price={allPrices.get(priceKey(court.venue_price_id, dayType, hour, hour + 1))}
										selectedField={selectedField}
										selectedSchedules={selectedSchedules}
										selectedDay={selectedDay}
										setSelectedField={setSelectedField}
										setSelectedSchedules={setSelectedSchedules}
										hideEmptyPrice={hideEmptyPrice}
										calendarWeeklyItems={calenderItems.get(calendarKey(court.id, hour, hour + 1))}
										weeksCount={weeksCount}
									/>
									)
								)}
							</div>
						))}
				</div>
			</div>
		</div>
	);
}

export default Calendar
